// LIST
export const FETCH_COMMENTS = "app/COMMENT/FETCH_COMMENTS";
export const FETCH_COMMENTS_SUCCESS = "app/COMMENT/FETCH_COMMENTS_SUCCESS";
export const FETCH_COMMENTS_FAILURE = "app/COMMENT/FETCH_COMMENTS_FAILURE";

// GET VIEW DATA
export const GET_VIEW_DATA = "app/COMMENT/GET_VIEW_DATA";
export const GET_VIEW_DATA_SUCCESS = "app/COMMENT/GET_VIEW_DATA_SUCCESS";
export const GET_VIEW_DATA_FAILURE = "app/COMMENT/GET_VIEW_DATA_FAILURE";

// ADD
export const ADD_COMMENT = "app/COMMENT/ADD_COMMENT";
export const ADD_COMMENT_SUCCESS = "app/COMMENT/ADD_COMMENT_SUCCESS";
export const ADD_COMMENT_FAILURE = "app/COMMENT/ADD_COMMENT_FAILURE";

// EDIT
export const EDIT_COMMENT = "app/COMMENT/EDIT_COMMENT";
export const EDIT_COMMENT_SUCCESS = "app/COMMENT/EDIT_COMMENT_SUCCESS";
export const EDIT_COMMENT_FAILURE = "app/COMMENT/EDIT_COMMENT_FAILURE";

// DELETE
export const DELETE_COMMENT = "app/COMMENT/DELETE_COMMENT";
export const DELETE_COMMENT_SUCCESS = "app/COMMENT/DELETE_COMMENT_SUCCESS";
export const DELETE_COMMENT_FAILURE = "app/COMMENT/DELETE_COMMENT_FAILURE";

export const SET_COMMENT_FILTERS = "app/COMMENT/SET_COMMENT_FILTERS";

export const TOGGLE_COMMENT_EDIT = "app/COMMENT/TOGGLE_COMMENT_EDIT";
